// var redirectUrlRaw = window.location.toString();
// var redirectUrl = redirectUrlRaw.toLowerCase();
// var qs = (function(a) {
//   if (a == "") return {};
//   var b = {};
//   for (var i = 0; i < a.length; ++i)
//   {
//     var p=a[i].split('=', 2);
//     if (p.length == 1)
//       b[p[0]] = "";
//     else
//       b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
//   }
//   return b;
// })(window.location.search.toLowerCase().substr(1).split('&'));
// var q = qs.q || '';

var redirectWhenMatchWord = [
  {
    words: [
      '1908',
      'Air King',
      'Air-King',
      'Cosmograph Daytona',
      'Datejust 31',
      'Datejust 36',
      'Datejust 41',
      'Datejust',
      'Day Date',
      'Day Date 40',
      'Day Date 36',
      'Day-Date',
      'Day-Date 40',
      'Day-Date 36',
      'Deepsea',
      'Explorer',
      'GMT Master',
      'GMT Master II',
      'GMT-Master',
      'GMT Master-II',
      'GMT-Master II',
      'Lady Datejust',
      'Lady-Datejust',
      'Oyster Perpetual',
      'Oyster Perpetual Date',
      'Rolex',
      'Rolex 1908',
      'Rolex Air King',
      'Rolex Air-King',
      'Rolex Cosmograph Daytona',
      'Rolex Datejust',
      'Rolex Datejust 31',
      'Rolex Datejust 41',
      'Rolex Datejust 36',
      'Rolex Day Date 40',
      'Rolex Day Date 36',
      'Rolex Day Date',
      'Rolex Day-Date 40',
      'Rolex Day-Date 36',
      'Rolex Day-Date',
      'Rolex Deepsea',
      'Rolex Explorer',
      'Rolex GMT Master',
      'Rolex GMT Master II',
      'Rolex GMT-Master',
      'Rolex GMT-Master II',
      'Rolex Lady Datejust',
      'Rolex Lady-Datejust',
      'Rolex Oyster Perpetual',
      'Rolex Sea Dweller',
      'Rolex Sea-Dweller',
      'Rolex Sky Dweller',
      'Rolex Sky-Dweller',
      'Rolex Submariner',
      'Rolex Turn-O-Graph',
      'Rolex Yacht Master',
      'Rolex Yacht-Master',
      'Sea Dweller',
      'Sea-Dweller',
      'Sky Dweller',
      'Sky-Dweller',
      'Submariner',
      'Turn-O-Graph',
      'Yach Master',
      'Yacht Master',
      'Yacht-Master',
      'Rolex CPO',
      'Rolex Certified Pre-owned',
      'Pre-owned Rolex',
      'Rolex pre-owned',
      'Pre owned Rolex',
      'Rolex pre owned',
      'Rolex used',
      'Daytona',
      'Used Rolex'
    ],
    redirectTo: 'https://www.hennejewelers.com/pages/rolex-search'
  },
  // {
  //   words: ['Rolex', 'Air-King', 'Cellini', 'Daytona', 'Datejust', 'Lady-Datejust', 'Day-Date', 'Explorer', 'GMT-Master', 'Milgauss', 'Oyster Perpetual', 'Pearlmaster', 'Sea-Dweller', 'Sky-Dweller', 'Submariner', 'Yacht-Master', 'Date just', 'Date-just', 'Lady Date just', 'Lady Date-just', 'Day Date', 'AirKing', 'Air-King', 'Lady’s Datejust', 'Lady’s Date-just', 'Ladies Datejust', 'Ladies Date-just', 'Milgaus', 'Mil gauss'],
  //   redirectTo: 'https://www.hennejewelers.com/pages/rolex'
  // },
  // {
  //   words: ['Cosmograph Daytona'],
  //   redirectTo: 'https://www.hennejewelers.com/pages/rolex-collection?cmplp=rolex-watches/cosmograph-daytona'
  // },
  // {
  //   words: ['GMT Master II', 'GMT-Master II'],
  //   redirectTo: 'https://www.hennejewelers.com/pages/rolex-collection?cmplp=rolex-watches/gmt-master-ii'
  // },
  // {
  //   words: ['1908'],
  //   redirectTo: 'https://www.hennejewelers.com/pages/rolex-collection?cmplp=rolex-watches/1908'
  // },
  {
    words: ['hjxcb', 'courtney brennan', 'courtney brennan', 'courtney', 'courtney brenna', 'courtney brennan collection'],
    redirectTo: 'https://www.hennejewelers.com/collections/hjxcb'
  }
]

// redirectWhenMatchWord.forEach((item) => {
//   var isRedirect = item.words.findIndex((w) => w.toLowerCase() === q.replace(/^\*+|\*+$/g, '')) >= 0;
//   if(isRedirect){
//     window.location.replace(item.redirectTo + '?search=' + q);
//   }
// });
// show preview when search not match rolex keywords

const initHeaderSearch = function() {
  var currentSearchForm = document.getElementById('HeaderSearchForm');
  var searchForm = currentSearchForm.cloneNode(true); // true means deep clone (including child nodes)
  currentSearchForm.parentNode.replaceChild(searchForm, currentSearchForm);
  searchForm = document.getElementById('HeaderSearchForm');
  // var searchForm = document.getElementById('HeaderSearchForm');
  var searchBtn = document.querySelectorAll('.site-header__search-btn--submit')[0];
  searchBtn.onclick = null;
  
  var searchSubmit = function(event) {
    var searchInput = searchForm.querySelectorAll('.site-header__search-input')[0];
    if (searchInput && searchInput.value.trim() !== '') {
      var search = searchInput.value.trim().toLowerCase();
      for (const item of redirectWhenMatchWord) {
        isRedirect = item.words.findIndex((w) => w.toLowerCase() === search.replace(/^\*+|\*+$/g, '')) >= 0;
        if (isRedirect) {
          window.location.replace(item.redirectTo + '?search=' + search);
          break;
        }
      }
      console.log('isRedirect', isRedirect);
      if (!isRedirect) {
        searchForm.submit();
        // beforeSubmitSearchForm('#bc-sf-search-box-0', event);
      }
    }
  }
  
  searchForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent the default form submission
    searchSubmit();
  });
  
  searchForm.addEventListener('keypress', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission
      searchSubmit();
    }
  });
  
  searchBtn.addEventListener('click', function(event) {
    console.log('click');
    event.preventDefault(); // Prevent the default form submission
    searchSubmit();
  });
};

const initSearchBar = function() {
  var currentSearchForm = document.getElementById('search-bar');
  var searchForm = currentSearchForm.cloneNode(true); // true means deep clone (including child nodes)
  currentSearchForm.parentNode.replaceChild(searchForm, currentSearchForm);
  searchForm = document.getElementById('search-bar');
  var searchBtn = document.querySelectorAll('.search-bar-btn')[0];
  searchBtn.onclick = null;
  
  var searchSubmit = function(event) {
    var searchInput = searchForm.querySelectorAll('.search-bar-input')[0];
    if (searchInput && searchInput.value.trim() !== '') {
      var search = searchInput.value.trim().toLowerCase();
      for (const item of redirectWhenMatchWord) {
        isRedirect = item.words.findIndex((w) => w.toLowerCase() === search.replace(/^\*+|\*+$/g, '')) >= 0;
        if (isRedirect) {
          window.location.replace(item.redirectTo + '?search=' + search);
          break;
        }
      }
      console.log('isRedirect', isRedirect);
      if (!isRedirect) {
        searchForm.submit();
      }
    }
  }
  
  searchForm.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent the default form submission
    searchSubmit();
  });
  
  searchForm.addEventListener('keypress', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission
      searchSubmit();
    }
  });
  
  searchBtn.addEventListener('click', function(event) {
    console.log('click');
    event.preventDefault(); // Prevent the default form submission
    searchSubmit();
  });
};

window.addEventListener('load', function(){
  // var searchForm = document.getElementById('HeaderSearchForm');
  // var previewWraper = document.getElementById('PredictiveWrapper');
  // var searchInput = searchForm.querySelectorAll('.site-header__search-input');
  // var timerTyping = 0;
  // var rolexKeyWords = redirectWhenMatchWord[0].words.join('|') + redirectWhenMatchWord[2].words.join('|');
  // var rolexRegex = new RegExp("(" + rolexKeyWords + ")", 'i');
  // searchInput[0].addEventListener('input', function(e){
  //   clearTimeout(timerTyping);
  //   timerTyping = setTimeout(function(){
  //     var isMatch = rolexRegex.test(e.target.value);
  //     previewWraper.classList.remove('show');
  //     if(!isMatch){
  //       previewWraper.classList.add('show');
  //     }
  //     clearTimeout(timerTyping);
  //   }, 500);
  // });
  initHeaderSearch();
  initSearchBar();
});

// set rolex search title
function getTitleFromSearch(obj, key) {
  const lowerCaseKey = key.toLowerCase();
  
  // Iterate through the object's keys
  for (const k of Object.keys(obj)) {
    if (k.toLowerCase() === lowerCaseKey) {
      return obj[k];
    }
  }
  
  return false;

}
const searchTitleData = {
  '1908': 'Looking for a Rolex 1908?',
  'Air King': 'Looking for a Rolex Air-King?',
  'Air-King': 'Looking for a Rolex Air-King?',
  'Cosmograph Daytona': 'Looking for a Rolex Cosmograph Daytona?',
  'Datejust 31': 'Looking for a Rolex Datejust?',
  'Datejust 36': 'Looking for a Rolex Datejust?',
  'Datejust 41': 'Looking for a Rolex Datejust?',
  'Datejust': 'Looking for a Rolex Datejust?',
  'Day Date': 'Looking for a Rolex Day-Date?',
  'Day Date 40': 'Looking for a Rolex Day-Date?',
  'Day Date 36': 'Looking for a Rolex Day-Date?',
  'Day-Date': 'Looking for a Rolex Day-Date?',
  'Day-Date 40': 'Looking for a Rolex Day-Date?',
  'Day-Date 36': 'Looking for a Rolex Day-Date?',
  'Deepsea': 'Looking for a Rolex Deepsea?',
  'Explorer': 'Looking for a Rolex Explorer?',
  'GMT Master': 'Looking for a Rolex GMT-Master?',
  'GMT Master II': 'Looking for a Rolex GMT-Master II?',
  'GMT-Master': 'Looking for a Rolex GMT-Master?',
  'GMT Master-II': 'Looking for a Rolex GMT-Master II?',
  'GMT-Master II': 'Looking for a Rolex GMT-Master II?',
  'Lady Datejust': 'Looking for a Rolex Lady-Datejust?',
  'Lady-Datejust': 'Looking for a Rolex Lady-Datejust?',
  'Oyster Perpetual': 'Looking for a Rolex Oyster Perpetual?',
  'Oyster Perpetual Date': 'Looking for a Rolex Oyster Perpetual?',
  'Rolex': 'Looking for a Rolex?',
  'Rolex 1908': 'Looking for a Rolex 1908?',
  'Rolex Air King': 'Looking for a Rolex Air-King?',
  'Rolex Air-King': 'Looking for a Rolex Air-King?',
  'Rolex Cosmograph Daytona': 'Looking for a Rolex Cosmograph Daytona?',
  'Rolex Datejust': 'Looking for a Rolex Datejust?',
  'Rolex Datejust 31': 'Looking for a Rolex Datejust?',
  'Rolex Datejust 41': 'Looking for a Rolex Datejust?',
  'Rolex Datejust 36': 'Looking for a Rolex Datejust?',
  'Rolex Day Date 40': 'Looking for a Rolex Day-Date?',
  'Rolex Day Date 36': 'Looking for a Rolex Day-Date?',
  'Rolex Day Date': 'Looking for a Rolex Day-Date?',
  'Rolex Day-Date 40': 'Looking for a Rolex Day-Date?',
  'Rolex Day-Date 36': 'Looking for a Rolex Day-Date?',
  'Rolex Day-Date': 'Looking for a Rolex Day-Date?',
  'Rolex Deepsea': 'Looking for a Rolex Deepsea?',
  'Rolex Explorer': 'Looking for a Rolex Explorer?',
  'Rolex GMT Master': 'Looking for a Rolex GMT-Master?',
  'Rolex GMT Master II': 'Looking for a Rolex GMT-Master II?',
  'Rolex GMT-Master': 'Looking for a Rolex GMT-Master?',
  'Rolex GMT-Master II': 'Looking for a Rolex GMT-Master II?',
  'Rolex Lady Datejust': 'Looking for a Rolex Lady-Datejust?',
  'Rolex Lady-Datejust': 'Looking for a Rolex Lady-Datejust?',
  'Rolex Oyster Perpetual': 'Looking for a Rolex Oyster Perpetual?',
  'Rolex Sea Dweller': 'Looking for a Rolex Sea-Dweller?',
  'Rolex Sea-Dweller': 'Looking for a Rolex Sea-Dweller?',
  'Rolex Sky Dweller': 'Looking for a Rolex Sky-Dweller?',
  'Rolex Sky-Dweller': 'Looking for a Rolex Sky-Dweller?',
  'Rolex Submariner': 'Looking for a Rolex Submariner?',
  'Rolex Turn-O-Graph': 'Looking for a Rolex Turn-O-Graph?',
  'Rolex Yacht Master': 'Looking for a Rolex Yacht-Master?',
  'Rolex Yacht-Master': 'Looking for a Rolex Yacht-Master?',
  'Sea Dweller': 'Looking for a Rolex Sea-Dweller?',
  'Sea-Dweller': 'Looking for a Rolex Sea-Dweller?',
  'Sky Dweller': 'Looking for a Rolex Sky-Dweller?',
  'Sky-Dweller': 'Looking for a Rolex Sky-Dweller?',
  'Submariner': 'Looking for a Rolex Submariner?',
  'Turn-O-Graph': 'Looking for a Rolex Turn-O-Graph?',
  'Yach Master': 'Looking for a Rolex Yacht-Master?',
  'Yacht Master': 'Looking for a Rolex Yacht-Master?',
  'Yacht-Master': 'Looking for a Rolex Yacht-Master?',
  'Daytona': 'Looking for a Rolex Cosmograph Daytona?'
};

let search = location.search.split('=');
if (search.length > 1 && search[0] === '?search') {
  let term = search[1];
  let $searchTitle = document.querySelector('.shogun-heading-component h1');
  if (term && $searchTitle) {
    term = decodeURIComponent(term);
    let title = getTitleFromSearch(searchTitleData, term);
    console.log(term, title);
    if (title) {
      $searchTitle.textContent = title;
    }
  }
}